import wheelFoundations from "./assets/wheel-foundations.png";
import surfaceStories from "./assets/surface-stories.png";
import handbuiltVessels from "./assets/handbuilt-vessels.png";
import glazeLab from "./assets/glaze-lab.png";
import wheelFoundationsWebp from "./assets/wheel-foundations.png?webp";
import surfaceStoriesWebp from "./assets/surface-stories.png?webp";
import handbuiltVesselsWebp from "./assets/handbuilt-vessels.png?webp";
import glazeLabWebp from "./assets/glaze-lab.png?webp";
export const STUDIO_CLASSES = [
    {
        id: "wheel-foundations",
        title: "Wheel Foundations",
        level: "Beginner",
        rhythm: "4 weeks · Saturdays",
        price: "$220",
        image: wheelFoundations,
        imageWebp: wheelFoundationsWebp,
        imageAlt: "Hands centering a speckled clay bowl on a pottery wheel",
        description: "Slow down, find center, and learn the essential motions behind cups and bowls that feel unmistakably yours.",
        accent: "clay",
    },
    {
        id: "handbuilt-forms",
        title: "Handbuilt Forms",
        level: "All levels",
        rhythm: "3 weeks · Wednesdays",
        price: "$185",
        image: handbuiltVessels,
        imageWebp: handbuiltVesselsWebp,
        imageAlt: "A sculptural terracotta vessel being shaped by hand with coils",
        description: "Pinch, coil, and slab-build expressive vessels without a wheel. Explore form through texture, rhythm, and play.",
        accent: "olive",
    },
    {
        id: "surface-stories",
        title: "Surface Stories",
        level: "Some experience",
        rhythm: "2 weeks · Thursdays",
        price: "$145",
        image: surfaceStories,
        imageWebp: surfaceStoriesWebp,
        imageAlt: "Ceramic cups being painted with cobalt underglaze at a shared table",
        description: "Turn your bisque pieces into small stories with underglaze, wax resist, carving, and confident brushwork.",
        accent: "blue",
    },
    {
        id: "open-glaze-lab",
        title: "Open Glaze Lab",
        level: "All levels",
        rhythm: "One day · Monthly",
        price: "$78",
        image: glazeLab,
        imageWebp: glazeLabWebp,
        imageAlt: "Colorful bowls beside glaze jars as green glaze is poured over a carved bowl",
        description: "A generous, guided day for testing combinations, learning glaze chemistry, and finishing work with intention.",
        accent: "yellow",
    },
];
export function studioClassById(id) {
    return STUDIO_CLASSES.find((studioClass) => studioClass.id === id) ?? STUDIO_CLASSES[0];
}
